import React from 'react';
import PropTypes from "prop-types";
import tsl from '../../app/tsl';
import { isNotEmpty } from './validations';

// This function takes a component...
export default function withValidations(WrappedComponent, requiredValidation, mapValidationErrorsToPropsFnc) {

  // ...and returns another component...
  return class extends React.Component {
    static propTypes = {
      validations: PropTypes.array,
      validateOnMount: PropTypes.bool,
      value: PropTypes.any.isRequired,
      onValid: PropTypes.func,
      onInvalid: PropTypes.func,
      formActions: PropTypes.object
    };

    static defaultProps = {
      validations: [],
      validateOnMount: false
    };

    reset = () => {
      this.setState({
        displayValidations: false,
        validationErrors: this.getValidationErrors(this.props) // this will correctly trigger onValid/onInvalid events
      });
    };

    mapValidationErrorsToProps = (validationErrors, props) => {
        if (mapValidationErrorsToPropsFnc) {
          return mapValidationErrorsToPropsFnc(validationErrors, props);
        }

        const hasError = validationErrors.length > 0;

        return {
          error: hasError || props.error,
          helperText: hasError && validationErrors.map((e, i) => <span key={e}>{i > 0 ? <span>, </span> : null}{e}</span>) || props.helperText
        }
    } ;

    constructor(props) {
      super(props);

      this.state = {
        displayValidations: props.validateOnMount || (props.formActions && props.formActions.isFormSubmitted),
        validationErrors: this.getValidationErrors(props)
      };
    }

    componentWillMount() {
      // although we may not be displaying validation errors, we need to set the initial valid/invalid state
      const validationErrors = this.getValidationErrors(this.props);
      this.setState({
        validationErrors,
      });

      if (this.props.formActions && this.props.formActions.register) {
        this.props.formActions.register(this);
      }
    }

    componentWillUnmount() {
      if (this.props.formActions && this.props.formActions.unregister) {
        this.props.formActions.unregister(this);
      }
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value && (isNotEmpty(this.props.value) === true || isNotEmpty(nextProps.value) === true)) {
        const validationErrors = this.getValidationErrors(nextProps);
        this.setState({
          validationErrors,
        });
      }
    }

    handleChange = (event) => {
      this.setState({
        displayValidations: true
      });

      this.props.onChange && this.props.onChange(event);
    };

    handleBlur = (event) => {
      this.setState({
        displayValidations: true
      });

      this.props.onBlur && this.props.onBlur(event);
    };

    getValidationErrors = (nextProps) => {
      const {
        validations,
        required,
        formActions
      } = nextProps;

      let validationErrors = [];

      if (validations.length > 0) {
        validationErrors = validations.reduce((acc, func) => {
          const res = func(nextProps.value);
          if (res !== true) {
            acc.push(res);
          }

          return acc;
        }, []);
      }

      if (required && requiredValidation) {
        if (requiredValidation(nextProps.value) !== true) {
          validationErrors.push(tsl('validations.value_is_required'));
        }
      }

      if (formActions) {
        if (validationErrors.length > 0) {
          formActions.onInvalid && formActions.onInvalid(this);
          this.props.onValid && this.props.onValid();
        } else {
          formActions.onValid && formActions.onValid(this);
          this.props.onValid && this.props.onInvalid();
        }
      }

      return validationErrors;
    };

    render() {
      const {
        validations,
        required,
        validateOnMount,
        onValid,
        onInvalid,
        formActions,
        ...componentProps
      } = this.props;

      const validationErrors = (this.state.displayValidations || (formActions && formActions.isFormSubmitted)) ? this.state.validationErrors : [];

      return (
        <WrappedComponent
          {...componentProps}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          {...this.mapValidationErrorsToProps(validationErrors, componentProps)}
        />
      );
    };
  };
}


// WEBPACK FOOTER //
// ./components/forms/withValidations.js